import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
import { Plus } from '@element-plus/icons-vue';
import CommonInfoDialog from './CommonInfoDialog.vue';
import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';

import { ref, watch, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XTableSelect',
  props: {
    placeholder: {
      default: '请选择'
    },
    modelValue: {},
    labelkey: {},
    valuekey: {},
    tabelColunm: {},
    searchItems: {},
    url: {},
    loadUrl: {}
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var REQUEST = global.globalVal[GLOBAL_DATA.TABLE_REQUEST];
    var props = __props;
    var emits = __emit;
    var commonInfoDialog = ref();
    var selectRows = ref([]);
    var options = ref([]);
    watch(function () {
      return props.modelValue;
    }, function () {
      selectRows.value = props.modelValue || [];
      if (props.modelValue && props.modelValue.length > 0) {
        var loadIds = [];
        props.modelValue.forEach(function (item) {
          var i = options.value.find(function (i) {
            return i[props.valuekey] === item;
          });
          if (!i) {
            loadIds.push(item);
          }
        });
        if (loadIds.length > 0) {
          loadIds.forEach(function (item) {
            REQUEST(props.loadUrl + '/' + item, null).then(function (res) {
              if (res.data) {
                options.value.push(res.data);
              }
            });
          });
        }
      }
    }, {
      immediate: true
    });
    var value = computed({
      get: function get() {
        return props.modelValue || [];
      },
      set: function set(newValue) {
        emits('update:modelValue', newValue);
      }
    });
    function select(rows) {
      options.value = _toConsumableArray(rows);
      selectRows.value = rows.map(function (item) {
        return item[props.valuekey];
      });
      emits('update:modelValue', selectRows.value);
    }
    function selectCommon() {
      var _commonInfoDialog$val;
      (_commonInfoDialog$val = commonInfoDialog.value) === null || _commonInfoDialog$val === void 0 || _commonInfoDialog$val.open();
    }
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        placeholder: "Please input",
        class: "input-with-select"
      }, {
        prepend: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: _unref(value),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(value) ? value.value = $event : null;
            }),
            placeholder: _ctx.placeholder,
            style: {
              "width": "115px"
            },
            multiple: ""
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), function (item, index) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item[props.labelkey],
                  value: item[props.valuekey]
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder"])];
        }),
        append: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: selectCommon,
            icon: _unref(Plus)
          }, null, 8, ["icon"])];
        }),
        _: 1
      }), _createVNode(CommonInfoDialog, {
        ref_key: "commonInfoDialog",
        ref: commonInfoDialog,
        onSelect: select,
        tabelkey: props.valuekey,
        "default-select": _unref(selectRows),
        url: props.url,
        tabelColunm: props.tabelColunm,
        searchItems: props.searchItems
      }, null, 8, ["tabelkey", "default-select", "url", "tabelColunm", "searchItems"])]);
    };
  }
});